<template>
  <v-card class="glass-card pa-4">
    <v-btn
      color="primary"
      variant="elevated"
      @click="loadStatistics"
    >
      Statistik laden (Test)
    </v-btn>
  </v-card>
</template>

<script>
export default {
  name: 'StatisticsTest',

  methods: {
    async loadStatistics() {
      try {
        const { data } = await this.$axios.get('/api/statistics/', {
          params: {
            start: '2025-01-01',
            end: '2025-01-31'
          }
        })
        console.log('STATISTICS RESPONSE:', data)
      } catch (err) {
        console.error('STATISTICS ERROR:', err)
      }
    }
  }
}
</script>

<style scoped>
.glass-card {
  background: rgba(255,255,255,0.72) !important;
  backdrop-filter: blur(8px) saturate(120%);
  border: 0.1rem solid rgba(255,255,255,0.35);
  overflow: visible;
  flex: 1 1 auto;
}
:deep(.v-theme--dark) .glass-card {
  background: rgba(17,24,39,0.60) !important;
  border: 0.1rem solid rgba(255,255,255,0.08);
}
</style>
